import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'
import packageInfo from '../package.json'

if (environment.production) {
  enableProdMode()

  Sentry.init({
    dsn: environment.sentry.dns,
    environment: environment.sentryName,
    release: packageInfo.version,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: environment.sentry.tracesSampleRate,

    tracePropagationTargets: ['localhost', environment.domain],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
